// @core/api/endpoints/project/remove_item.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/project';

/**
 * Remove item from project
 * Removes an item from the project without deleting the underlying source task. The task continues to exist in its product TaskService.
 */
export async function RemoveItem(
  project_id: string,
  item_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/items/:item_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':item_id', encodeURIComponent(item_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
